import * as React from 'react'
import { GridDensityTypes, GridSlotsComponent } from '../models'
import {
  DataGridProcessedProps,
  DataGridPropsWithDefaultValues,
  DataGridProps,
} from '../models/props/DataGridProps'
import { DATA_GRID_DEFAULT_SLOTS_COMPONENTS } from '../constants'

const DATA_GRID_FORCED_PROPS: {
  apiRef: DataGridProcessedProps['apiRef']
} = {
  apiRef: undefined,
}

/**
 * The default values of `DataGridPropsWithDefaultValues` to inject in the props of DataGrid.
 */
export const DATA_GRID_PROPS_DEFAULT_VALUES: DataGridPropsWithDefaultValues = {
  columnBuffer: 3,
  rowBuffer: 3,
  columnThreshold: 3,
  rowThreshold: 3,
  headerHeight: 56,
  rowHeight: 52,
  columnFooterHeight: 52,
  hideFooter: false,
  hideHeader: false,
  hideColumnHeader: false,
  density: GridDensityTypes.Standard,
  autoHeight: false,
  disableVirtualization: false,
  showCellRightBorder: false,
  showColumnRightBorder: false,
  showColumnGrouping: false,
  disableExtendRowFullWidth: false,
  disableColumnReorder: false,
  disableMultipleRowSelectionWithCheckboxSelection: false,
  disableSelectAll: false,
  keepColumnPositionIfDraggedOutside: false,
  overscrollBehaviorX: 'auto',
  overscrollBehaviorY: 'auto',
  checkboxSelection: false,
  disableMultipleRowSelection: false,
  disableRowSelectionOnClick: false,
  rowSelection: true,
  rowCount: 0,
  pageSize: 20,
  footerPlacement: false,
  footerData: {},
  showSortingIndex: false,
  editMode: 'cell',
}

export const useDataGridProps = (inProps: DataGridProps) => {
  const components = React.useMemo<GridSlotsComponent>(() => {
    const overrides = inProps.components
    if (!overrides) {
      return { ...DATA_GRID_DEFAULT_SLOTS_COMPONENTS }
    }
    const mergedComponents = {} as GridSlotsComponent
    type GridSlots = keyof GridSlotsComponent

    Object.entries(DATA_GRID_DEFAULT_SLOTS_COMPONENTS).forEach(
      ([key, defaultComponent]) => {
        mergedComponents[key as GridSlots] =
          // @ts-ignore
          overrides[key as GridSlot] === undefined
            ? defaultComponent
            : overrides[key as GridSlots]
      }
    )

    return mergedComponents
    /* eslint-disable-next-line */
  }, [inProps.components, inProps.checkboxSelection])

  return React.useMemo<DataGridProcessedProps>(
    () => ({
      ...DATA_GRID_PROPS_DEFAULT_VALUES,
      ...DATA_GRID_FORCED_PROPS,
      ...inProps,
      components,
    }),
    [components, inProps]
  )
}
